import * as React from "react";
import {
  footerContainer,
  footerlinkList,
  footerlinkHead,
  menu,
  show,
} from "./FooterLinks.module.scss";
import { Link } from "gatsby";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { slugify } from "transliteration";
import { Storage } from "../../../../utils/storage";
import { Constants } from "../../../../@types/Constants";
import { useSelector } from "react-redux";
import { useMobileDetectContext } from "../../../../context/MobileDetectContext";

export const Container: React.FC<any> = (props) => {
  return <div className={footerContainer}>{props.children}</div>;
};

export const LinkGroup: React.FC<any> = (props) => {
  const { isMobileOnly } = useMobileDetectContext(); // Use your custom hook to detect mobile
  const isLoggedIn = useSelector((state: any) => state.member.isLoggedIn);

  const buttonStyles = {
    fontSize: "14px",
    color: "#ffffff",
    background: "none",
    border: "none",
    padding: "0",
    cursor: "pointer",
    textDecoration: "none",
    ...(isMobileOnly && {
      display: "block",
      padding: "8px",
      fontSize: "18px",
    }),
  };

  const toggleCookieDrawer = () => {
    const osano = (window as any)?.Osano?.cm;
    if (osano?.showDrawer) {
      osano.showDrawer("osano-cm-dom-info-dialog-open");
    } else {
      console.warn("Osano CMP not ready");
    }
  };

  const ClearBrandBias = () => {
    Storage.ClearLocalStorageValue(Constants.BRAND_BIAS_KEY);
  };

  return (
    <div className={`${footerlinkList} ${props.showMenu ? show : ""}`}>
      <div
        className={footerlinkHead}
        onClick={props.handleShowMenu}
        data-menu={props.groupLinks.field_footer_group.toLowerCase()}
      >
        <span
          id={`footer-${slugify(props.groupLinks.field_footer_group)}`}
          data-menu={props.groupLinks.field_footer_group.toLowerCase()}
        >
          {props.groupLinks.field_footer_group}
        </span>
        <FontAwesomeIcon
          icon={props.showMenu ? faChevronUp : faChevronDown}
          onClick={props.handleShowMenu}
          data-menu={props.groupLinks.field_footer_group.toLowerCase()}
        />
      </div>
      <ul className={menu} style={{ listStyleType: "none" }}>
        {props.groupLinks.field_footer_link.map((links: any, index: number) => {
          return (
            <li key={`group-link${index}`}>
              {links.url === "/onetrustpreferencecenter" ? (
                <button
                  id="ot-sdk-btn"
                  className="ot-sdk-show-settings"
                  style={buttonStyles}
                  onClick={toggleCookieDrawer}
                >
                  {links.title}
                </button>
              ) : links.url === "/manage-reservation" ? (
                <Link
                  to={isLoggedIn ? "/account" : "/manage-reservation"}
                  id={slugify(links.title)}
                  onClick={ClearBrandBias}
                >
                  {links.title}
                </Link>
              ) : links.url.includes("http") || links.url.includes("com") ? (
                <a
                  href={links.url}
                  id={slugify(links.title)}
                  target="_blank"
                  rel="noreferrer"
                >
                  {links.title}
                </a>
              ) : (
                <Link
                  to={links.url}
                  id={slugify(links.title)}
                  onClick={ClearBrandBias}
                >
                  {links.title}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
